var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-icon"},[(_vm.photo)?_c('img',{attrs:{"src":_vm.photo,"alt":_vm.name}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }